import moment from 'moment-timezone';

import {toFixed} from './';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_TIMEZONE,
  MAX_DESCRIPTION_LEN,
} from './constants';

export const removeTimezone = dateStr =>
  dateStr ? moment.tz(dateStr, 'UTC').format(DEFAULT_DATE_FORMAT) : dateStr;

export const convertFormat = format => {
  let convertedFormat = format || DEFAULT_DATE_FORMAT;

  convertedFormat = convertedFormat
    .replace(/tt/g, 'A')
    .replace(/y/g, 'Y')
    .replace(/d/g, 'D')
    .replace(/DDD/g, 'ddd');

  return convertedFormat;
};

export const formatDate = (
  dateStr,
  timezone = DEFAULT_TIMEZONE,
  format = DEFAULT_DATE_FORMAT,
  emptyText = '',
  isUtc = false,
) => {
  if (!dateStr) {
    return emptyText || '';
  }

  const date = isUtc ? moment.tz(dateStr, 'UTC') : moment.tz(dateStr, timezone);

  return date.tz(timezone).format(convertFormat(format));
};

export const formatDateWithoutTimezone = (
  dateStr,
  format = DEFAULT_DATE_FORMAT,
  emptyText = '',
) =>
  dateStr ? moment(dateStr).format(convertFormat(format)) : emptyText || '';

export const formatDescription = (desc, maxLen = MAX_DESCRIPTION_LEN) =>
  desc && desc.length > maxLen ? `${desc.substring(0, maxLen)}...` : desc;

export const formatNumber = number =>
  number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';

export const formatAddress = loc => {
  if (!loc) return '';

  let addr = loc.address1 ? loc.address1 : '';

  if (loc.address2) {
    addr = `${addr}${addr ? ', ' : ''}${loc.address2}`;
  }

  if (loc.city) {
    addr = `${addr}${addr ? ', ' : ''}${loc.city}`;
  }

  if (loc.state) {
    addr = `${addr}${addr ? ', ' : ''}${loc.state}`;
  }

  if (loc.countryId) {
    addr = `${addr}${addr ? ', ' : ''}${loc.countryId}`;
  }

  if (loc.postalCode) {
    addr = `${addr}${addr ? ' ' : ''}${loc.postalCode}`;
  }

  if (loc.zip) {
    addr = `${addr}${addr ? ' ' : ''}${loc.zip}`;
  }

  return addr;
};

export const formatRate = (rate, override = false) => {
  if (rate === null || rate === undefined) return '';
  const num = Number(rate);
  return ((Math.abs(num) * 100) % 1).toFixed(1) > 0 || override
    ? toFixed(num, 3)
    : toFixed(num, 2);
};

export const formatDuration = totalMins => {
  const mins = totalMins % 60;
  return `${totalMins >= 60 ? Math.floor(totalMins / 60) : 0}:${
    mins > 10 ? mins : `0${mins}`
  }`;
};

export const pad = (number, size) => {
  let str = String(number);

  while (str.length < size) {
    str = `0${str}`;
  }

  return str;
};



// WEBPACK FOOTER //
// ./src/helpers/formatter.js